// extracted by mini-css-extract-plugin
module.exports = {"container":"_4Mr_oB849-JUho7WMjIbW","row":"_1qF5IF7S6GtAgduEnEQQdO","moreCoursesButton":"_1STRUhwtEmZx9oF63aCCWp"};